export const getCustomerAddressId = (address) => address?.addressId
export const getBasketAddressId = (address) => address?.c_ID
